
import Vue from "vue";
import { Table, TableColumn } from "element-ui";

export default Vue.extend({
  name: "CountyAvailabilityTable",
  components: {
    "el-table": Table,
    "el-table-column": TableColumn
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    showAction: {
      type: Boolean,
      default: false
    }
  }
});
